import React, { Component } from "react";
import styles from "./../../../assets/css/modules/containers/detail-container.css";

export default class DetailContainer extends Component {
  render() {
    return <div className={styles.detailContainer}>{this.props.children}</div>;
  }
}
